module.exports = __webpack_public_path__ + "media/images/new-ui-images/blue-total-ba9bf4c88722e9ef9df26d8c6975a894.svg";